jQuery(function ($) {
	$(document).ready(function () {

		initJS = (function () {

			var

				init = function () {
					_initDOM();
					_initNavSticky();
					_initNavMobile();
					_initDropdown();
					_initSectionActive();
					_initFadeLogos();
					_initContentActive();
					_initFaq();
					_initCovidFaq();
					_initCovidPopup();
					_initOverlay();
					_initFixedSidebar();
					_initTeamSlider();
					_initPlatformsSlider();
					//_initTimeline();
					_initAboutRotator();
					_initReporstPopup();
					_initNewsletterPopup();
					_initLightbox();
					_initResourceCenterVideoGuidesPlay();
					_initResourceCenterThankYouMessage();
					_initResoirceCenterFormToggler();
					_initIntegrationPartnersPopup();
				},

				finalize = function () {
				},

				_initDOM = function () {
				},

				_initNavMobile = function () {
					$('#navbar-toggle').click(function () {
						$(this).toggleClass('active');
						$('body').toggleClass('mobile-nav-active');
						$('#mobile-navigation').toggleClass('active');
					});

					if ($(window).width() < 1200) {
						$('#mobile-navigation .navbar-nav > li.dropdown > a').click(function (e) {
							e.preventDefault();
							if ($(this).parent().hasClass('active')) {
								$(this).parent().removeClass('active');
								$('#mobile-navigation .navbar-nav > li > a').not($(this)).parent().removeClass('hide').slideDown(200);
								$(this).parent().find('.dropdown-menu').slideUp(200);
							} else {
								$(this).parent().addClass('active');
								$('#mobile-navigation .navbar-nav > li > a').not($(this)).parent().addClass('hide').slideUp(200);
								$(this).parent().find('.dropdown-menu').slideDown(200);
							}
						});
					}
				},

				_initNavSticky = function () {
					if ($('#main-navigation').hasClass('navbar-fixed')) {
						$('body').addClass('fixed-nav-active');

						$(window).scroll(function () {
							if ($(window).scrollTop() > $('#main-navigation').outerHeight()) {
								$('.navbar-custom').addClass('is-fixed is-visible');
							} else {
								$('.navbar-custom').removeClass('is-visible is-fixed');
							}
						});
					}
				},

				_initDropdown = function () {
					if ($(window).width() > 1199) {
						$('#main-navigation.main-navbar .navbar-nav > li.dropdown > a').click(function (e) {
							e.preventDefault;
						});

						$('#main-navigation li.dropdown').on({
							mouseenter: function () {
								//$( this ).find( '.dropdown-menu' ).addClass( 'active' );

								$(this).find('.dropdown-menu li').each(function (i) {
									var item = $(this);
									setTimeout(function () {
										item.css('opacity', 1);
									}, 50 * i);
								});
							},
							mouseleave: function () {
								clearTimeout();
								var dropdown = $(this).find('.dropdown-menu');

								$(this).find('.dropdown-menu li').each(function (i) {
									$(this).css('opacity', 0);
								});
							}
						});

						var navHeight = $('#main-navigation').outerHeight() - 40;

						$('#main-navigation .navbar-nav > li').on({
							mouseenter: function () {
								var dropdown = $(this).find('.dropdown-menu'),
									dropdownHeight = $(this).find('.dropdown-menu').outerHeight();

								if (dropdown.length > 0) {
									mainNavHeight = navHeight + dropdownHeight;
								} else {
									mainNavHeight = navHeight + dropdownHeight + 40;
								}

								$('#main-navigation').animate({ height: mainNavHeight }, 300);
							},
							mouseleave: function () {

							}
						});

						$('#menu-main-menu').on({
							mouseleave: function () {
								$('#main-navigation').animate({ height: navHeight + 40 }, 300);
							}
						});
					}
				},

				_initSectionActive = function () {
					var scrollTop = $(document).scrollTop();

					$('.section').each(function () {
						var offsetTop = $(this).offset().top;

						if (scrollTop > offsetTop - $(window).height()) {
							$(this).addClass('active');
						}

						/**
						 * Draw icons on 'Contact' page
						 */
						if ($(this).hasClass('contact-columns')) {
							function drawIcons() {
								$('.contact-columns__icon svg').addClass('draw');
							}
							setTimeout(drawIcons, 850)
						}
					});

					$(document).scroll(function (e) {
						var scrollTop = $(document).scrollTop();

						$('.section').each(function () {
							var offsetTop = $(this).offset().top;

							if ($(window).width() > 767 && scrollTop > offsetTop - $(window).height() / 2) {
								/** add active class on scroll for desktop devices */
								$(this).addClass('active')
							} else if ($(window).width() < 767 && scrollTop > offsetTop - $(window).height() / 1.4) {
								/** add active class on scroll for mobile devices */
								$(this).addClass('active');
							}
						});
					})
				},

				_initFadeLogos = function () {
					var scrollTop = $(document).scrollTop();

					$('.partners__logotypes-item ').each(function () {
						var offsetTop = $(this).offset().top;

						if (scrollTop > offsetTop - $(window).height()) {
							$(this).addClass('active');
						}
					});

					$(document).scroll(function (e) {
						var scrollTop = $(document).scrollTop();

						$('.partners__logotypes-item ').each(function () {
							var offsetTop = $(this).offset().top;

							if ($(window).width() > 767 && scrollTop > offsetTop - $(window).height() / 1.1) {
								/** add active class on scroll for desktop devices */
								$(this).addClass('active')
							} else if ($(window).width() < 767 && scrollTop > offsetTop - $(window).height() / 1.1) {
								/** add active class on scroll for mobile devices */
								$(this).addClass('active');
							}
						});
					})
				},

				_initContentActive = function () {
					if ($('.plain-text').length > 0) {
						$(document).scroll(function (e) {
							var scrollTop = $(document).scrollTop();

							$('.plain-text p, .plain-text ul, .plain-text h2, .plain-text h3, .plain-text .plain-text__contact').each(function () {
								var offsetTop = $(this).offset().top;

								if (scrollTop > offsetTop - $(window).height() / 1.2) {
									$(this).addClass('active');
								}
							});
						});

						$('.plain-text p, .plain-text ul, .plain-text h2, .plain-text h3, .plain-text .plain-text__contact').each(function () {
							var scrollTop = $(document).scrollTop();
							var offsetTop = $(this).offset().top;

							if (scrollTop > offsetTop - $(window).height()) {
								$(this).addClass('active');
							}
						});
					}
				},

				_initFaq = function () {
					$('.faq__question').click(function () {
						$(this).parent().find('.faq__answer').slideToggle(200);
						$(this).parent().toggleClass('active');
					});
				},

				_initCovidFaq = function () {
					$('.covid-faq__item-question').click(function (event) {
						event.preventDefault();
						$(this).parent().toggleClass('active');
						$(this).parent().find('.covid-faq__item-answer').slideToggle(200);
					});
				},

				_initCovidPopup = function () {
					$('.covid-popup__close').click(function () {
						$('body').removeClass('popup-active');
						$(this).parents('.covid-popup').removeClass('active');
					});

					$('.covid-popup__form-thanks-close').click(function () {
						$('body').removeClass('popup-active');
						$(this).parents('.covid-popup').removeClass('active');
					});

					$('.popup-covid-organizations').click(function () {
						$('body').addClass('popup-active');
						$('.covid-popup--organizations').addClass('active');
					});
				},

				_initOverlay = function () {
					$('#blog_categories_button').click(function () {
						$('body').addClass('overlay-active');
						$('#category_overlay').addClass('active');
					});

					$('.overlay__close').click(function () {
						$('.overlay').addClass('hiding');

						function hideEffecct() {
							$('body').removeClass('overlay-active');
							$('.overlay').removeClass('active').removeClass('hiding');
						}
						setTimeout(hideEffecct, 1100);
					});

					$('#blog_search_button').click(function () {
						$('body').addClass('overlay-active');
						$('#search_overlay').addClass('active');
					});
				},

				_initFixedSidebar = function () {
					if ($('#fixed_sidebar').length > 0) {
						var offsetTop = $('#fixed_sidebar').offset().top,
							sidebarWidgetsHeight = $('#fixed_sidebar .sidebar__inner').outerHeight(),
							stopper = $('.stopper').offset().top + 30;
						bottomPosition = stopper - offsetTop - sidebarWidgetsHeight;

						$(document).scroll(function (e) {
							var scrollTop = $(document).scrollTop(),
								scrollOffsetTop = $('#fixed_sidebar .sidebar__inner').offset().top;

							if (scrollTop > offsetTop - 250 && scrollTop + sidebarWidgetsHeight + 250 < stopper) {
								$(this).find('.sidebar__inner').css({ position: 'fixed', top: 250 });
							} else if (scrollTop > offsetTop - 250 && scrollOffsetTop + sidebarWidgetsHeight > stopper) {
								$(this).find('.sidebar__inner').css({ position: 'absolute', top: bottomPosition });
							} else if (scrollTop < offsetTop) {
								$(this).find('.sidebar__inner').css({ position: 'absolute', top: 0 });
							}
						});
					}
				},

				_initTeamSlider = function () {
					/**
					 * Init team members swiper
					 */

					if ($(window).width() > 767) {
						var dragsize = 64;
					} else {
						var dragsize = 48;
					}

					var swiper = new Swiper('.team__slider-container', {
						slidesPerView: 'auto',
						spaceBetween: 0,
						centeredSlides: true,
						touchRatio: 0,
						slideToClickedSlide: true,
						scrollbar: {
							el: '.team__slider-scrollbar',
							hide: false,
							dragSize: dragsize,
							draggable: true,
						},
					});

					if ($('.team').length > 0) {
						/**
						* Set the middle slide as active
						*/
						var slidesCount = swiper.slides.length - 1,
							setActiveSlide = Math.ceil(slidesCount / 2);

						swiper.slideTo(setActiveSlide, 200);

						/**
						* Set muted property to false
						*/
						$('.team__person-video').each(function () {
							$(this).prop('muted', false);
						});

						/**
						* Play video thumbnail on hover
						*/
						$('.team__slide-media').hover(function (e) {
							var video = $(this).find('.team__person-video-thumbnail');
							$(video).trigger('play');
							$(video).loop = true;
						}, function (e) {
							var video = $(this).find('.team__person-video-thumbnail');
							if (video !== undefined) {
								$(video).trigger('pause');
								$(video).loop = false;
							}
						});

						/**
						* Play video on play button click
						*/
						$('.team__slide #play').click(function (e) {
							var video = $(this).parents('.team__slide-media').find('.team__person-video');
							$(this).addClass('active');
							$(this).parents('.team__slide-media').addClass('active');
							$(video).trigger('play');
						});
					}

					/**
					 * Mute/unmute video on mute button click
					 */
					$('.team__slide #mute').click(function () {
						var video = $(this).parents('.team__slide-media').find('.team__person-video'),
							muteStatus = $(video).prop('muted');

						$(this).toggleClass('noactive');

						if (muteStatus == false) {
							$(video).prop('muted', true);
						} else {
							$(video).prop('muted', false);
						}
					});

					/**
					 * Stop video when user click on it
					 */
					$('.active .team__person-image').click(function () {
						$(this).parent().find('.team__person-video').trigger('pause');
						$(this).parent().removeClass('active');
						$(this).parent().find('#play').removeClass('active');
					});

					$('.team__person-video').on('ended', function () {
						$(this).parent().removeClass('active');
						$('.team__slide #play').removeClass('active');
					});

					/**
					 * Remove active class, stop and unmute video on slide change
					 */
					swiper.on('slideChange', function () {
						$('.swiper-slide-active .team__person-video').each(function () {
							$(this).trigger('pause');
							$(this)[0].currentTime = 0;
							$(this).parent().removeClass('active');
							$(this).parent().find('#play').removeClass('active');
							if ($(this).prop('muted') == true) {
								$(this).prop('muted', false);
								$(this).parent().find('#mute').addClass('noactive');
							}
						});
					});
				},

				_initPlatformsSlider = function () {
					var swiper = new Swiper('.platforms__slider-circle', {
						slidesPerView: 6,
						spaceBetween: 35,
						loop: true,
						autoplay: {
							delay: 5000,
						},
						breakpoints: {
							440: {
								slidesPerView: 2,
								spaceBetween: 18
							},
							992: {
								slidesPerView: 4,
								spaceBetween: 24
							}
						},
						navigation: {
							nextEl: '.swiper-button-next',
							prevEl: '.swiper-button-prev',
						}
					});

					var swiper = new Swiper('.platforms__slider-rectangle', {
						slidesPerView: 3,
						spaceBetween: 20,
						loop: true,
						autoplay: {
							delay: 5000,
						},
						breakpoints: {
							767: {
								slidesPerView: 1,
								spaceBetween: 40
							},
							992: {
								slidesPerView: 2,
								spaceBetween: 24
							}
						},
						navigation: {
							nextEl: '.swiper-button-next',
							prevEl: '.swiper-button-prev',
						}
					});
				},

				_initTimeline = function () {
					if ($('#difference-timeline').length > 0) {
						var timelineOffsetTop = $('#difference-timeline').offset().top,
							timelineHeight = $('#difference-timeline').outerHeight(),
							timelineLastItemOffset = $('.difference__timeline-wrapper').children().last().find('.timeline-point').offset().top;
						windowHeight = $(window).height();

						$(window).on('scroll', function () {
							scrollTop = $(document).scrollTop();

							if (scrollTop > timelineOffsetTop - 200 - windowHeight) {
								if ($('#timeline-line').outerHeight() < timelineLastItemOffset - timelineOffsetTop) {
									$('#timeline-line').css({ height: (scrollTop) });
								} else {
									$('#timeline-line').css({ height: (timelineHeight) })
									$('.difference__timeline-end').addClass('active');
								}
							};

							$('.timeline-point').each(function (index, value) {
								var pointOffset = $(this).offset().top;

								if ($('#timeline-line').outerHeight() + timelineOffsetTop > pointOffset) {
									$(this).addClass('active');
									$(this).parent().find($('.difference__item-col')).addClass('active');
								} else if ($('#timeline-line').outerHeight() + timelineOffsetTop < pointOffset && $('#timeline-line').outerHeight() < timelineHeight) {
									$(this).removeClass('active');
									$(this).parent().find($('.difference__item-col')).removeClass('active');
								}
							});
						});
					}
				},

				_initAboutRotator = function () {
					var sliders = document.getElementsByClassName("photo-rotator");

					[].forEach.call(sliders, function (div, i) {
						var slides = div.getElementsByClassName("slide"),
							current = 0,
							index = i + 1;

						setInterval(function () {
							for (var i = 0; i < slides.length; i++) {
								slides[i].style.opacity = 0;
							}
							current = (current != slides.length - 1) ? current + 1 : 0;
							slides[current].style.opacity = 1;
						}, 2500 + (index * 1533));
					});
				},

				_initReporstPopup = function () {
					$('.reports__buttons .popup-button').click(function () {
						var popupAttr = $(this).attr('data-popup');

						$('.reports__popup').addClass('active');
						$('.download-popup__inner[data-popup=' + popupAttr + ']').addClass('active');
					});

					$('.download-popup__close').click(function () {
						$(this).parents('.download-popup__inner').removeClass('active');
						$('.reports__popup').removeClass('active');
					});


					$.extend({
						getUrlVars: function () {
							var vars = [], hash;
							var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
							for (var i = 0; i < hashes.length; i++) {
								hash = hashes[i].split('=');
								vars.push(hash[0]);
								vars[hash[0]] = hash[1];
							}
							return vars;
						},
						getUrlVar: function (name) {
							return $.getUrlVars()[name];
						}
					});

					if ($.getUrlVar("thanks") == 'employment') {
						$('.reports__popup').addClass('active');
						$('.download-popup__inner[data-popup=employment]').addClass('active');
						$('.download-popup__inner[data-popup=employment]').find('.download-popup__step--1').removeClass('active');
						$('.download-popup__inner[data-popup=employment]').find('.download-popup__step--2').addClass('active');
					}

					if ($.getUrlVar("thanks") == 'deep-dive') {
						$('.reports__popup').addClass('active');
						$('.download-popup__inner[data-popup=deep-dive]').addClass('active');
						$('.download-popup__inner[data-popup=deep-dive]').find('.download-popup__step--1').removeClass('active');
						$('.download-popup__inner[data-popup=deep-dive]').find('.download-popup__step--2').addClass('active');
					}
				},

				_initNewsletterPopup = function () {
					$('.newsletter-button').click(function () {
						$('.newsletter-popup').addClass('active');
						$('body').addClass('popup-open');
					});

					$('.newsletter-popup__close').click(function () {
						$('.newsletter-popup').removeClass('active');
						$('body').removeClass('popup-open');
					});


					// $.extend({
					// 	getUrlVars: function(){
					// 		var vars = [], hash;
					// 		var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
					// 		for(var i = 0; i < hashes.length; i++)
					// 		{
					// 			hash = hashes[i].split('=');
					// 			vars.push(hash[0]);
					// 			vars[hash[0]] = hash[1];
					// 		}
					// 		return vars;
					// 	},
					// 	getUrlVar: function(name){
					// 		return $.getUrlVars()[name];
					// 	}
					// });

					// if ( $.getUrlVar("newsletter") == 'thanks' ) {
					// 	$( '.newsletter-popup' ).addClass( 'active' );
					// 	$( '.newsletter-popup' ).find( '.newsletter-popup__step--1' ).removeClass( 'active' );
					// 	$( '.newsletter-popup' ).find( '.newsletter-popup__step--2' ).addClass( 'active' );
					// }
				},

				_initLightbox = function () {
					$('[data-toggle="lightbox"]').click(function (e) {
						e.preventDefault();
						$(this).ekkoLightbox();
					});
				};

			_initResourceCenterVideoGuidesPlay = function () {
				var videos = document.querySelectorAll("[data-video]");

				videos.forEach(function (item) {
					var videoItem = item.querySelector("[data-video-embed");

					videoItem.autoplay = false;
					var playButton = videoItem.firstElementChild;

					playButton.addEventListener('click', function () {
						var iframe = videoItem.querySelector('iframe');
						var videoSrc = iframe.getAttribute('src');
						var autoplay = videoSrc.concat('&autoplay=1&enablejsapi=1&playsinline=1');

						iframe.setAttribute('src', autoplay);
						playButton.style.display = 'none';
						videoItem.classList.add('active');
						videoItem.parentNode.classList.add('active');
					});
				})
			};

			_initResourceCenterThankYouMessage = function () {
				var wpcf7Elm = document.querySelectorAll('[data-rc-form] .wpcf7');
				var closeMessage = document.querySelectorAll('[data-rs-ty-close]');
				var message = document.querySelector('[data-rs-ty]');

				if (!message && closeMessage.length == 0) return;

				closeMessage.forEach(function (close) {
					close.addEventListener('click', function () {
						message.classList.remove('active');
					});
				});

				wpcf7Elm.forEach(function (form) {
					form.addEventListener('wpcf7mailsent', function () {
						message.classList.add('active');
					}, false);
				})
			};

			_initResoirceCenterFormToggler = function() {
				var nav = document.querySelector('.resource-center__contact-toggler-nav');

				if (! nav) {
					return;
				}

				var buttons = nav.querySelectorAll('button');
				var forms = document.querySelectorAll('.resource-center__contact-form-wrapper');

				for (var i = 0; i < buttons.length; i++) {
					buttons[i].addEventListener("click", function() {
						for (var j = 0; j < buttons.length; j++) {
							buttons[j].classList.remove('--active');
						}

						this.classList.add('--active');
						var form = this.getAttribute('data-form');

						forms.forEach(function(formWrapper) {
							if (formWrapper.getAttribute('data-form') === form) {
								formWrapper.classList.add('--active');
							} else {
								formWrapper.classList.remove('--active');
							}
						});
					});
				}
			};

			_initIntegrationPartnersPopup = function() {
				var partners = document.querySelectorAll('.partners__logotypes-item');

				if (0 >= partners.length) {
					return;
				}

				partners.forEach(function(partner) {
					var description = partner.querySelector('.logotype-description');

					if (! description) {
						return;
					}

					partner.classList.add('has-popup');
					partner.addEventListener('click', function openPopup() {
						var popup = document.querySelector('.logotype-description-popup');

						if (! popup) {
							return;
						}

						var content = popup.querySelector('.logotype-description-popup__content');
						var close = popup.querySelector('.logotype-description-popup__close');
						

						if (! content || ! close) {
							return;
						}

						content.innerHTML = description.innerHTML;

						document.body.classList.add('popup-open');
						popup.classList.add('active');

						close.addEventListener('click', function closePopup() {
							popup.classList.remove('active');
							document.body.classList.remove('popup-open');

							close.removeEventListener('click', closePopup);
						});
					});
				});
			}

			return {
				init: init,
				finalize: finalize
			};

		}());

	});
});
